import React from "react";
import PropTypes from "prop-types";

import { useTrans } from "../../../../hooks";
import ContestFormField from "../ContestFormField";
import { NewCheckbox } from "../../../../shared-components";
import ErrorField from "./ErrorField";

const ExclusivityField = ({
  form,
  disableForm,
  onRadioBtnChange,
  fieldStatus,
  submitted
}) => {
  const { trans } = useTrans();

  const title = trans("Platform exclusivity");

  const subtitle = (
    <>
      <div className="subtitle">
        {/* prettier-ignore */ trans("Upon notification that your story is on the Wattys shortlist, you must immediately remove the story from any other digital platform(s) that it is posted on, if any. Your story must be posted exclusively on Wattpad for the period between us notifying you of your story’s shortlist qualification and the date we announce the Wattys winners. Watty-winning stories must continue to be posted exclusively on Wattpad for one year from the date we announce the Wattys winners. I agree that my story is or will be exclusively posted on Wattpad in accordance with the above paragraph.")}
      </div>
    </>
  );

  const errorCondition =
    (fieldStatus.fieldInvalid ||
      (fieldStatus.fieldName !== "platformExclusivity" &&
        fieldStatus.fieldName !== "" &&
        submitted)) &&
    !form.platformExclusivity;

  const errorMessage = errorCondition
    ? trans("This checkbox is required.")
    : "";

  return (
    <ContestFormField title={title} subtitle={subtitle}>
      <>
        <div className="checkbox-group" id="is-exclusive-select">
          <NewCheckbox
            name="platformExclusivity"
            disabled={disableForm}
            checked={form.platformExclusivity}
            onChange={onRadioBtnChange}
            contentId="is-exclusive-message"
          >
            {trans("I agree")}
          </NewCheckbox>
        </div>
        <ErrorField errorMessage={errorMessage} fieldId={"exclusivity"} />
      </>
    </ContestFormField>
  );
};

ExclusivityField.propTypes = {
  form: PropTypes.object.isRequired,
  disableForm: PropTypes.bool.isRequired,
  onRadioBtnChange: PropTypes.func.isRequired,
  fieldStatus: PropTypes.shape({
    fieldInvalid: PropTypes.bool,
    fieldName: PropTypes.string
  }).isRequired,
  submitted: PropTypes.bool.isRequired
};

export default ExclusivityField;
